























import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Settle from './Settle.vue'
import Query from './Query.vue'

@Component({
	name: 'addBillTask',
	components: {
		Settle,
		Query,
		PageLayout,
	},
})
export default class addTaskPage extends Vue {
	private active: any = '1'

	private toggle(i: any) {
		this.active = i
	}
}
